import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-papi-types';
import { actionKey } from '../constants';
import { OriginalDeviationFormFields } from '../../modals/OriginalDeviationPopup/types';
import { OriginalDeliverySubmitFormData } from '../types';

export const createOriginalDeviation = createAction(
  `${actionKey}.CREATE_ORIGINAL_DEVIATION`,
  (payload: {
    formData: OriginalDeviationFormFields;
    onSuccess?: (originalDeviation: PapiDeviation) => void;
    onError?: (response: any) => void;
  }) => payload
);

export const updateOriginalDeviation = createAction(
  `${actionKey}.UPDATE_ORIGINAL_DEVIATION`,
  (payload: {
    deviationId: number;
    formData: OriginalDeviationFormFields;
    onSuccess?: (originalDeviation: PapiDeviation) => void;
    onError?: (response: any) => void;
  }) => payload
);

export const publishOriginalDeviation = createAction(
  `${actionKey}.PUBLISH_ORIGINAL_DEVIATION`,
  (payload: { deviationId: number; onSuccess?: () => void; onError?: (response: any) => void }) =>
    payload
);

/** Opens the original edit modal, fetching the init data first */
export const editOriginalDeviation = createAction(
  `${actionKey}.EDIT_ORIGINAL_DEVIATION`,
  (payload: { deviationId: number }) => payload
);

export const submitOriginalDelivery = createAction(
  `${actionKey}.SUBMIT_ORIGINAL_DELIVERY`,
  (payload: {
    formData: OriginalDeliverySubmitFormData;
    doDeliver: boolean;
    onSuccess?: () => void;
    onError?: (response: any) => void;
  }) => payload
);
